import { ApplicationConfig, isDevMode, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { rootReducer, metaReducers } from './core/stores/store';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { UserEffects } from './core/stores/user/user.effects';
import { httpInterceptor } from './core/helpers/http.interceptor';
import { DealerEffects } from './core/stores/dealer/dealer.effects';
import { EquipmentEffects } from './core/stores/equipment/equipment.effects';
import { DashboardEffects } from './core/stores/dashboard/dashboard.effects';
import { AccountsEffects } from './core/stores/account/account.effects';
import { EventEffects } from './core/stores/event/event.effects';
import { ApikeyEffects } from './core/stores/apikey/apikey.effects';
import { WebhookEffects } from './core/stores/webhook/webhook.effects';
import { ForwarderEffects } from './core/stores/forwarder/forwarder.effects';
import { ClickEffects } from './core/stores/click/click.effects';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideStore(rootReducer, {
      metaReducers
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideEffects(
      [
        UserEffects,
        DashboardEffects,
        EquipmentEffects,
        AccountsEffects,
        DealerEffects,
        EventEffects,
        ApikeyEffects,
        WebhookEffects,
        ForwarderEffects,
        ClickEffects
      ]
    ),

    // NgRx Store Devtools
    provideStoreDevtools({
      maxAge: 20,
      logOnly: !isDevMode()
    }),

    // HTTP Providers
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi()
    ),
    { provide: HTTP_INTERCEPTORS, useClass: httpInterceptor, multi: true },

  ]
}